function onscreen(){
	var element = $('.fadeIn, .btn--underline');
	var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
	var top_of_screen = $(window).scrollTop();
	var offset = 50;

	element.each(function(index, value) {
		var top_of_element = $(value).offset().top;
		var bottom_of_element = $(value).offset().top + $(value).outerHeight();
		if ((bottom_of_screen > top_of_element - offset) && (top_of_screen < bottom_of_element - offset)){
			$(value).addClass('onscreen');
		} else {
 			// $this.removeClass('onscreen');
		}

	});
}

function onscreenMap(){
	var element = $('.blockMap');
	var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
	var top_of_screen = $(window).scrollTop();
	var offset = -($(window).height()/2);

	element.each(function(index, value) {
		var top_of_element = $(value).offset().top;
		var bottom_of_element = $(value).offset().top + $(value).outerHeight();
		if ((bottom_of_screen > top_of_element - offset) && (top_of_screen < bottom_of_element - offset)){
			$(value).addClass('onscreen');
		}

	});
}

$(document).ready(function(){
	onscreen();
	onscreenMap();
	setTimeout(function(){
		onscreen();
		onscreenMap();
	},300);
	$(window).on('load scroll resize orientationchange', function(){
	  onscreen();
	  onscreenMap();
	});
});